import React from 'react';
import { ProductName } from '../Styles/ProductName';
import { AddressBarMenuIcon, ExGiv } from '../react-constants';


export const ExtensionInstructionsView = () => (
	<>
		<h3>Recording websites' behavior and network traffic</h3>
		<ol>
			<li><b>Open a new tab to record in.</b></li>
			<li>From the pinned icon in your address bar, <b>press "Start recording this tab"</b>.</li>
			<ul>
				<li>You will be able to choose whether to video record your interactions with the website.
					If you do, immediately after you press "Start recording this tab" you will be prompted to choose whether to record the tab or window.
					<ul>
						<li>Choose <i>tab</i> if no other tabs will be opened and need to be recorded, and if and you don't want to record the address bar.
							It will record the smallest screen area with the fewest distractions.</li>
						<li>Choose <i>window</i> to video record the address bar and any tab in view, including new tabs that may be opened during recording.</li>
						<li>Choose <i>screen</i> to include action that may take place on your screen outside the current browser window, including any popup windows.</li>
					</ul>
				</li>
				<li>
					You will be able to choose where <ProductName /> will open a panel with live search and reports. You may open the panel…
					<ul>
						<li><i>in the side of the tab</i> to see search results right next to the app, but the font sizes will be small to make the panel fit there, and if you are recording the tab or window everything you see and do in the panel will be recorded.</li>
						<li><i>in a new window</i> is better if you have space on your screen.</li>
						<li><i>in a new tab</i> is better if you don't have space on your screen for a new window.</li>
						<li><i>later</i> will not immediately open a search panel, so that you can focus on recording now and search your recording later.
							You can still access the panel via the "MyDataGoesWhere?!" tab the extension adds to your developer tools. This tab will not appear on the "New Tab" page or other browser pages. It appears once you navigate to a website.
						</li>
					</ul>
				</li>
			</ul>
			<li>If you want to record network data in HTTP Archive (HAR) archive format, you will need to <b>open your browser's developers tools</b>. You can do this via the "Developers Tools" item from your browsers ellipsis (⋮ or …) menu, though it may also be accessible via the keyboard function key F12.</li>

			<li><b>Navigate to the website you want to record</b>, such as by typing or pasting the address of that site into your browser's address bar.</li>
			<li><b>Use the website</b> while recording is on to record the website's behavior and network traffic.</li>
			<li>When you are done recording, <b>turn recording off</b> either from the pinned icon used to start recording, or via the option in the panel. The recording is saved in a database within your browser.
				<br />
				<b>Do not close the primary tab (the one you started recording) until you have turned recording off.</b> HTTP Archives are saved when you turn recording off. If you close the tab before an HTTP Archive is saved, it will be lost.
			</li>
		</ol>
		<p>
			Limitations and annoyances:
		</p>
		<ul>
			<li><b>An HTTP Archive (HAR) is only recorded for the primary tab (the one you start recording from).</b> When a tab you are recording opens a new tab or window, <ProductName /> is able to record network traffic data from that new tab or window in other formats, but the browser cannot provide this in HTTP Archive (HAR) format as it requires the Debugger Tools to be opened for that tab, and the Debugger Tools will not open without user intervention.</li>
			<li>Every time you start a recording with video turned on, your browser will force you to select the tab/window to be recorded, even though the extension knows which one you want to record and you probably want the same behavior every time. This process is purportedly to protect you from having an app (Chrome) or extension (<ProductName />) record your screen without your knowledge, but gives you no way to override it.</li>
			<li>Your browser may show a warning that recording is happening, and your browser does not give you an option to permanently turn these warnings off.</li>

		</ul>
		
		<h3>Accessing and recordings</h3>
			<p>From the Extension's menu pinned to the address bar (the&nbsp;<AddressBarMenuIcon/>&nbsp icon) and select <i>Open recordings</i>.
			Press on any recording to open it.
			You may need to wait for search to complete before seeing results.
			</p>

		<h3>Analyzing recordings of websites</h3>
			<p>
				From the recording panel, you can type search terms, as well as add or remove search terms
				suggested based on text you've typed into the web page being recorded and the names of URLs
				you have navigated to. (Suggested search terms in green are searched for automatically, whereas those in red will only be searched for if you press on the plus button to add them to your list of search terms.)
			</p>
			<p><ProductName/> recognizes common formats for email addresses, US phone numbers (<ExGiv/>"+1 (555) 867-5309", or "55585705309"), IP addresses (<ExGiv/>"192.168.1.1"), US zip codes (<ExGiv/> "43210", "43210-1234"), and UUIDs, and will automatically search for other common variations of these formats, so you only need to include one variant in your search terms.
			</p>
			<p>
				In the search terms to use between sites, consider adding cross-site user identifiers: <ExGiv/> your Facebook Pixel (FBP cookie) and user id, as well as those for SnapChat, TikTok, and others.
			</p>


	</>
);
